import React, { useState } from "react";
import { useScrollAnimation } from "../../utils/Utils";
import { toast } from 'react-toastify'
import COUNTRIES from '../../utils/COUNTRIESLIST'
import { MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import {Link} from "react-router-dom";

const CONTACT_CONTROL_CLASS = "contact-control min-h-[56px] w-full text-base leading-6 transition outline-none";
const CONTACT_CONTROL_STYLE = {
  "--contact-placeholder": "#94a3b8",
  border: "1px solid #e2e8f0",
  borderRadius: "999px",
  padding: "12px 18px",
  color: "#0f172a",
  background: "#ffffff",
  outline: "none",
};
const CONTACT_SELECT_STYLE = {
  ...CONTACT_CONTROL_STYLE,
  appearance: "none",
  backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 16px center",
  paddingRight: "44px",
  cursor: "pointer",
};
const CONTACT_READONLY_STYLE = {
  ...CONTACT_CONTROL_STYLE,
  color: "#94a3b8",
  background: "#f8fafc",
  padding: "12px 14px",
};

const handleContactControlFocus = (event) => {
  event.currentTarget.style.borderColor = "#ea580c";
  event.currentTarget.style.boxShadow = "0 0 0 3px rgba(234,88,12,0.12)";
};

const handleContactControlBlur = (event) => {
  event.currentTarget.style.borderColor = "#e2e8f0";
  event.currentTarget.style.boxShadow = "none";
};

const Contact = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    company: "",
    jobtitle:"",
    workemail: "",
    country: "",
    countrycode: "",
    mobilenumber: "",
      nicheindustry: "",
    hearUs:"",
      about: "",
    agreement: false,
  });

  
  const [errors, setErrors] = useState({});
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
     console.log(e)
    // If country is selected, automatically set the country code
    if (name === "country") {
      const selectedCountry = COUNTRIES.find(country => country.code === value);
      setFormData({
        ...formData,
        [name]: value,
        countrycode: selectedCountry ? selectedCountry.dialCode : "",
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  
    // Validate the input field while typing
    validateField(name, value, type === "checkbox" ? checked : value);
  };
  // Field validation for live error checking
  const validateField = (name, value, checked) => {
    let error = "";
  
    switch (name) {
      case "fullname":
        if (!value) error = "Full Name is required";
        break;
  
      case "company":
        if (!value) error = "Company Name is required";
            break;
        case "jobtitle":
        if (!value) error = "JobTitle  is required";
        break;
  
      case "workemail":
        if (!value) {
          error = "Work Email is required";
        } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
          error = "Email address is invalid";
        }
        break;
  
      case "country":
        if (!value) error = "Country is required";
        break;
  
      case "countrycode":
        if (!value) error = "Country Code is required";
        break;
  
      case "mobilenumber":
        if (!value) {
          error = "Mobile Number is required";
        } else if (!/^\d+$/.test(value)) {
          error = "Mobile Number must contain only digits";
        } 
        // else if (value.length !== 10) {
        //   error = "Mobile Number must be exactly 10 digits";
        // }
        break;
  
      case "nicheindustry":
        if (!value) error = "Niche Industry is required";
        break;
  
      case "about":
        if (!value) error = "Please tell us how we can help you";
        break;
  
      case "agreement":
        if (!checked) error = "You must accept the agreement";
        break;
  
      default:
        break;
    }
  
    setErrors((prevErrors) => {
      if (error) {
        return { ...prevErrors, [name]: error }; // Set error if validation fails
      } else {
        const { [name]: removedError, ...rest } = prevErrors; // Remove error if validation passes
        return rest;
      }
    });
  };
  
  // Validation for all fields on submit
const validate = () => {
    let formErrors = {};
  
    // Full Name Validation
    if (!formData.fullname) formErrors.fullname = "Full Name is required";
  
    // Company Validation
      if (!formData.company) formErrors.company = "Company Name is required";
  // job title validation
       if (!formData.jobtitle) formErrors.jobtitle = "Job Title is required";
  
    // Work Email Validation
    if (!formData.workemail) {
      formErrors.workemail = "Work Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.workemail)) {
      formErrors.workemail = "Email address is invalid";
    }
  
    // Country Validation
    if (!formData.country) formErrors.country = "Country is required";
  
    // Country Code Validation
    if (!formData.countrycode) formErrors.countrycode = "Country Code is required";
  
    // Mobile Number Validation
    if (!formData.mobilenumber) {
      formErrors.mobilenumber = "Mobile Number is required";
    } else if (!/^\d+$/.test(formData.mobilenumber)) {
      formErrors.mobilenumber = "Mobile Number must contain only digits";
    } 
    // else if (formData.mobilenumber.length !== 10) {
    //   formErrors.mobilenumber = "Mobile Number must be exactly 10 digits";
    // }
  
    // Niche Industry Validation
    if (!formData.nicheindustry)
          formErrors.nicheindustry = "Niche Industry is required";
        // Niche Industry Validation
    if (!formData.hearUs)
          formErrors.hearUs = "How Did You Hear Us is required";
  
    // About Validation
    if (!formData.about)
      formErrors.about = "Please tell us how we can help you";
  
    // Agreement Validation
    if (!formData.agreement)
      formErrors.agreement = "You must accept the agreement";
  
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  
  };

 

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validate()) {
        // Form submission logic
        console.log("Form data submitted:", formData);

        toast.info("Submitting your inquiry...   ", {
            position:"top-right",
            autoClose: 10000, // Auto-close after 10 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
        try {          
          const response = await fetch('https://globalbackend-expressjs.onrender.com/api/kcstech/contact', {
        method: 'POST', 
        headers: {
            'Content-Type': 'application/json', 
        },
        body: JSON.stringify(formData), 
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json(); // Parse the JSON from the response
    console.log(data); // Handle the response data as needed
          
              setFormData({
                fullname: "",
                company: "",
                jobtitle:"",
                workemail: "",
               country: "",
               countrycode: "",
               mobilenumber: "",
               nicheindustry: "",
               hearUs:"",
               about: "",
               agreement: false,
               })
       // Show success message using Toastify
            toast.success("Email sent successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
            });
            console.log('Success:', response.data); // Handle success response

        } catch (error) {
          console.error('Error submitting form:', error); // Handle error
          
          toast.error("Error sending email. Please try again.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
            });
        }
    } else {
      console.log("Validation errors:", errors);
        
          toast.error("Please fix the validation errors.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
            });
    }
};

  const [selectedOfficeCountry, setSelectedOfficeCountry] = useState("Singapore");

// const officeaddressesamerica = [
//   {
//     country: "United States",
//     company: "Kapil Tech Inc",
//     address: `1603 Capitol Ave. Suite #310, Cheyenne,`,
//     pincode: "Wyoming - 820010",
//     email: "info@kapiltech.com",
//     gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/USA.gif?updatedAt=1782215227200",
//   },
// ];

const officeaddressesasiapacific = [
  {
    country: "Singapore",
    company: "Kapil Tech Singapore",
    address: `#13-01, 105 Cecil Street,`,
    pincode: "The Octagon - 069534",
    email: "info@kapiltech.com",
    gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/Singapore.gif?updatedAt=1782215226941",
  },
  {
    country: "Indonesia",
    company: "Kapil Tech Indonesia",
    address: `BSD Green Office Park 1, 6th Floor Jl. BSD Green Office Park, BSD City,`,
    pincode: "Tangerang - 15345",
    email: "info@kapiltech.com",
    gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/Indonesia.gif?updatedAt=1782215226756",
  },
  {
    country: "India",
    company: "Kapil Tech India",
    address: `Kapil Kavuri Hub, Nanakramguda, Gachibowli, Hyderabad`,
    pincode: "Telangana - 500032",
    email: "info@kapiltech.com",
    gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/India.gif?updatedAt=1782215227291",
  },
  {
    country: "United States",
    company: "Kapil Tech Inc",
    address: `1603 Capitol Ave. Suite #310, Cheyenne,`,
    pincode: "Wyoming - 820010",
    email: "info@kapiltech.com",
    gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/USA.gif?updatedAt=1782215227200",
  },
  // {
  //   country: "Thailand",
  //   company: "Kapil Tech Thailand",
  //   altercompany: "( c/o Business Systemation Solution )",
  //   address: `7/3 Moo. 7 Bangna Trad Rd., Bangchalong, Bangplee,`,
  //   pincode: "Samutprakarn - 105040",
  //   email: "info@kapiltech.com",
  //   gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/Thailand.gif?updatedAt=1782215226748",
  // },
  // {
  //   country: "Sri Lanka",
  //   company: "Kapil Tech Sri Lanka",
  //   altercompany: "( c/o Kraey Globe Limited )",
  //   address: `39/10, Rampart Road, Ethul Kotte,`,
  //   pincode: "Kotte - 10100",
  //   email: "info@kapiltech.com",
  //   gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/Srilanka.gif?updatedAt=1782215227147",
  // },
  // {
  //   country: "Fiji",
  //   company: "Kapil Tech Fiji",
  //   altercompany: "( c/o Alpha Technologies )",
  //   address: `58 Vomo Street, Lautoka,`,
  //   pincode: "Fiji Islands - 00000",
  //   email: "info@kapiltech.com",
  //   gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/FIJI.gif?updatedAt=1782215227421",
  // },
  // {
  //   country: "Malaysia",
  //   company: "Kapil Tech Malaysia",
  //   address: `Unit A805, No.1, Lorong Ultra B, Off Jalan Utara, 46200 Petaling Jaya,`,
  //   pincode: "Selangor - 528225",
  //   email: "info@kapiltech.com",
  //   gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/Malaysia.gif?updatedAt=1782215227517",
  // },
  // {
  //   country: "Cambodia",
  //   company: "Kapil Tech Cambodia",
  //   altercompany: "( c/o Cambodiasoft )",
  //   address: `Building #101A, St. 289, Sangkat Boeung Kak I, Khan Toul Kok,`,
  //   pincode: "Phnom Penh - 120407",
  //   email: "info@kapiltech.com",
  //   gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/Cambodia.gif?updatedAt=1782215223479",
  // },
];

const officeaddressesmiddleeast = [
  // {
  //   country: "Egypt",
  //   company: "Kapil Tech Egypt",
  //   altercompany: "( c/o Info Blendtec )",
  //   address: `OP90 Business Complex, Office 339, Southern Teseen St., Zone 3`,
  //   pincode: "5th Settlement New Cairo- 11835",
  //   email: "info@kapiltech.com",
  //   gif: "https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Contact%20us/Egypt.gif?updatedAt=1782215223458",
  // },
];

const officeAddresses = [
  ...officeaddressesasiapacific,
  ...officeaddressesmiddleeast,
];

const selectedOffice =
  officeAddresses.find(
    (office) => office.country === selectedOfficeCountry
  ) || officeAddresses[0];

const AddressCard = ({ address }) => (
  <div
    className="mt-5 rounded-2xl border bg-white p-5 shadow-sm"
    style={{ borderColor: "#e2e8f0" }}
  >
    <div className="flex items-center gap-4">
      {address.gif && (
        <img
          src={address.gif}
          alt={`${address.country} flag`}
          className="h-20 w-36 object-fit"
        />
      )}
      <div>
        <h3 className="mt-1 text-xl font-semibold text-[#001534] flex items-center">
          {address.country}
          {address.country === "Singapore" && (
            <span className="text-[10px] font-bold bg-orange-200 text-orange-800 px-2 py-0.5 rounded-full ml-2">
              HQ
            </span>
          )}
        </h3>
      </div>
    </div>

    <h4 className="mt-5 text-lg font-semibold text-slate-900">
      {address.company}
    </h4>
    {address.altercompany && (
      <p className="mt-1 text-xs leading-5 text-slate-500">
        {address.altercompany}
      </p>
    )}
    <div className="mt-4 flex items-start gap-3 text-sm leading-6 text-slate-600">
      <MapPin size={18} className="mt-0.5 flex-shrink-0 text-orange-600" />
      <p
        className="min-w-0 flex-1 text-left"
        style={{
          textWrap: "balance",
          wordSpacing: "normal",
          overflowWrap: "break-word",
        }}
      >
        {address.address} {address.pincode}
      </p>
    </div>
    <a
      href={`mailto:${address.email}`}
      className="mt-3 flex items-center gap-3 text-sm text-slate-600 transition hover:text-orange-600"
    >
      <Mail size={18} className="flex-shrink-0 text-orange-600" />
      <span>{address.email}</span>
    </a>
  </div>
);


  useScrollAnimation();

  return (
    <div>
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage:
              'url("https://ik.imagekit.io/7wqj9br0b/Training%20Website/Contact/Screenshot%202025-11-24%20185415.png")',
          }}
        >
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        {/* Foreground Content */}
        <div className="relative z-10 py-20 sm:py-24 md:py-32">
          <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center text-white">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold drop-shadow-lg">
              Contact Us
            </h1>

            <div className="breadcrumb flex items-center justify-center gap-2 mt-4">
              <Link
                to='/'
                className="text-white hover:text-blue-200 hover:underline transition-colors duration-200 drop-shadow-md"
              >
                Home
              </Link>
              <span className="w-1 h-1 bg-white rounded-full mx-2 drop-shadow-md"></span>
              <span className="text-white drop-shadow-md">Contact Us</span>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Cards section*/}
      <section
      className="py-24 px-4"
      style={{ backgroundColor: "#001534" }} // bg-indigo-50
    >
      <div className="max-w-5xl mx-auto justify-center">

        {/* Phone Card */}
        {/* <div className="p-6 rounded-xl shadow-sm bg-white">
          <div className="mb-4">
            <Phone size={28} style={{ color: "#0bfaaaff" }} />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            +91 88899 92746
          </h3>
          <p className="text-gray-600 mb-4">
            Mon to Sat: 9.00am to 5.00pm <br />
            Sun: 9.00am to 12.00pm
          </p>
          <button
            className="font-medium flex items-center"
            style={{ color: "#2563EB" }}
          >
            CALL NOW
            <ArrowRight size={16} className="ml-1" />
          </button>
        </div> */}

        {/* Email Card */}
        <div className="p-6 rounded-xl shadow-sm bg-white">
          <div className="mb-4">
            <Mail size={28} style={{ color: "#0df5edff" }} />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            info@kapiltech.com
          </h3>
          <p className="text-gray-600 mb-4">
            Reach out to our team by sending us an email—we’re here to assist
            you with your inquiries.
          </p>
          <button
            className="font-medium flex items-center"
            style={{ color: "#2563EB" }}
          >
            CONTACT US
            <ArrowRight size={16} className="ml-1" />
          </button>
        </div>

      </div>
      </section>


      {/* Contact Form Section */}
      <section style={{ background: "#ffffff" }}>
        <div className="container mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
          <div className="grid items-stretch gap-6 lg:grid-cols-12">

            {/* Offices */}
            <aside
              className="h-full rounded-2xl border bg-slate-50 p-5 shadow-sm sm:p-6 lg:col-span-5"
              style={{ borderColor: "#e2e8f0" }}
            >
              <h2 className="mt-2 text-3xl font-semibold text-[#001534]">
                Our Offices
              </h2>

              <div
                className="mt-2 grid grid-cols-2 gap-2"
                role="tablist"
                aria-label="Office countries"
              >
                {officeAddresses.map((office) => {
                  const isSelected =
                    selectedOfficeCountry === office.country;

                  return (
                    <button
                      key={office.country}
                      type="button"
                      role="tab"
                      aria-selected={isSelected}
                      onClick={() =>
                        setSelectedOfficeCountry(office.country)
                      }
                      className={`rounded-xl border px-3 py-2.5 text-left text-sm font-medium transition flex items-center justify-between ${
                        isSelected
                          ? "bg-orange-50 text-orange-700 shadow-sm"
                          : "bg-white text-slate-700 hover:bg-slate-50 hover:text-orange-700"
                      }`}
                      style={{
                        borderColor: isSelected ? "#fdba74" : "#e2e8f0",
                      }}
                    >
                      <span>{office.country}</span>
                      {office.country === "Singapore" && (
                        <span className="text-[10px] font-bold bg-orange-200 text-orange-800 px-1.5 py-0.5 rounded-full ml-2">
                          HQ
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>

              <div role="tabpanel">
                <AddressCard address={selectedOffice} />
              </div>
            </aside>

            {/* Contact form */}
            <div
              className="h-full lg:col-span-7"
              style={{ border: "1px solid #e2e8f0", borderRadius: "16px", background: "#ffffff", padding: "clamp(20px, 3vw, 30px)" }}
            >

            {/* Header */}
            <h2 className="mb-4 text-2xl font-semibold text-[#001534] sm:text-3xl">
              Let's Connect
            </h2>

            <form onSubmit={handleSubmit}>

              {/* Row 1: Name + Company */}
              <div className="grid gap-x-5 gap-y-5 sm:grid-cols-2">
                <div>
                  <label htmlFor="name" className="mb-2 block text-base font-normal leading-6" style={{ color: "#000000" }}>
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="name"
                    value={formData.fullname}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    className={CONTACT_CONTROL_CLASS}
                    style={CONTACT_CONTROL_STYLE}
                    onFocus={handleContactControlFocus}
                    onBlur={handleContactControlBlur}
                    aria-invalid={Boolean(errors.fullname)}
                    aria-describedby={errors.fullname ? "fullname-error" : undefined}
                  />
                  <div className="h-3 pt-0.5">
                    {errors.fullname && <span id="fullname-error" className="text-xs" style={{ color: "#dc2626" }}>{errors.fullname}</span>}
                  </div>
                </div>

                <div>
                  <label htmlFor="company" className="mb-2 block text-base font-normal leading-6" style={{ color: "#000000" }}>
                    Company Name
                  </label>
                  <input
                    type="text"
                    name="company"
                    id="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Enter your company"
                    className={CONTACT_CONTROL_CLASS}
                    style={CONTACT_CONTROL_STYLE}
                    onFocus={handleContactControlFocus}
                    onBlur={handleContactControlBlur}
                    aria-invalid={Boolean(errors.company)}
                    aria-describedby={errors.company ? "company-error" : undefined}
                  />
                  <div className="h-3 pt-0.5">
                    {errors.company && <span id="company-error" className="text-xs" style={{ color: "#dc2626" }}>{errors.company}</span>}
                  </div>
                </div>
              </div>

              {/* Row 2: Email + Job Title */}
              <div className="mt-1 grid gap-x-5 gap-y-5 sm:grid-cols-2">
                <div>
                  <label htmlFor="email" className="mb-2 block text-base font-normal leading-6" style={{ color: "#000000" }}>
                    Work Email
                  </label>
                  <input
                    type="email"
                    name="workemail"
                    id="email"
                    value={formData.workemail}
                    onChange={handleChange}
                    placeholder="Enter your work email"
                    className={CONTACT_CONTROL_CLASS}
                    style={CONTACT_CONTROL_STYLE}
                    onFocus={handleContactControlFocus}
                    onBlur={handleContactControlBlur}
                    aria-invalid={Boolean(errors.workemail)}
                    aria-describedby={errors.workemail ? "workemail-error" : undefined}
                  />
                  <div className="h-3 pt-0.5">
                    {errors.workemail && <span id="workemail-error" className="text-xs" style={{ color: "#dc2626" }}>{errors.workemail}</span>}
                  </div>
                </div>

                <div>
                  <label htmlFor="jobtitle" className="mb-2 block text-base font-normal leading-6" style={{ color: "#000000" }}>
                    Job Title
                  </label>
                  <input
                    type="text"
                    name="jobtitle"
                    id="jobtitle"
                    value={formData.jobtitle}
                    onChange={handleChange}
                    placeholder="Enter your job title"
                    className={CONTACT_CONTROL_CLASS}
                    style={CONTACT_CONTROL_STYLE}
                    onFocus={handleContactControlFocus}
                    onBlur={handleContactControlBlur}
                    aria-invalid={Boolean(errors.jobtitle)}
                    aria-describedby={errors.jobtitle ? "jobtitle-error" : undefined}
                  />
                  <div className="h-3 pt-0.5">
                    {errors.jobtitle && <span id="jobtitle-error" className="text-xs" style={{ color: "#dc2626" }}>{errors.jobtitle}</span>}
                  </div>
                </div>
              </div>

              {/* Divider */}
              <hr style={{ border: "none", borderTop: "1px solid #f1f5f9", margin: "8px 0" }} />

              {/* Row 3: Country + Mobile */}
              <div className="grid gap-x-5 gap-y-5 sm:grid-cols-2">
                <div>
                  <label htmlFor="country" className="mb-2 block text-base font-normal leading-6" style={{ color: "#000000" }}>
                    Country
                  </label>
                  <select
                    id="country"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    className={CONTACT_CONTROL_CLASS}
                    style={CONTACT_SELECT_STYLE}
                    onFocus={handleContactControlFocus}
                    onBlur={handleContactControlBlur}
                    aria-invalid={Boolean(errors.country)}
                    aria-describedby={errors.country ? "country-error" : undefined}
                  >
                    <option value="" disabled>Select Country</option>
                    {COUNTRIES.map((country) => (
                      <option key={country.code} value={country.code}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                  <div className="h-3 pt-0.5">
                    {errors.country && <span id="country-error" className="text-xs" style={{ color: "#dc2626" }}>{errors.country}</span>}
                  </div>
                </div>

                <div>
                  <label htmlFor="mobilenumber" className="mb-2 block text-base font-normal leading-6" style={{ color: "#000000" }}>
                    Mobile Number
                  </label>
                  <div className="grid grid-cols-3 gap-4">
                    <input
                      type="text"
                      name="countrycode"
                      readOnly
                      value={formData.countrycode}
                      placeholder="Code"
                      className={`${CONTACT_CONTROL_CLASS} col-span-1`}
                      style={CONTACT_READONLY_STYLE}
                      aria-label="Country calling code"
                    />
                    <input
                      type="tel"
                      name="mobilenumber"
                      id="mobilenumber"
                      value={formData.mobilenumber}
                      onChange={handleChange}
                      placeholder="Mobile number"
                      className={`${CONTACT_CONTROL_CLASS} col-span-2`}
                      style={CONTACT_CONTROL_STYLE}
                      onFocus={handleContactControlFocus}
                      onBlur={handleContactControlBlur}
                      aria-invalid={Boolean(errors.mobilenumber)}
                      aria-describedby={errors.mobilenumber ? "mobilenumber-error" : undefined}
                    />
                  </div>
                  <div className="h-3 pt-0.5">
                    {errors.mobilenumber && <span id="mobilenumber-error" className="text-xs" style={{ color: "#dc2626" }}>{errors.mobilenumber}</span>}
                  </div>
                </div>
              </div>

              {/* Divider */}
              <hr style={{ border: "none", borderTop: "1px solid #f1f5f9", margin: "8px 0" }} />

              {/* Row 4: Niche Industry + How did you hear */}
              <div className="grid gap-x-4 sm:grid-cols-2">
                <div>
                  <label htmlFor="nicheindustry" className="block text-sm font-medium mb-2" style={{ color: "#000000" }}>
                    Niche Industry
                  </label>
                  <input
                    type="text"
                    name="nicheindustry"
                    id="nicheindustry"
                    value={formData.nicheindustry}
                    onChange={handleChange}
                    placeholder="Your niche industry"
                    className="w-full text-sm transition"
                    style={{ border: "1px solid #e2e8f0", borderRadius: "999px", padding: "12px 18px", color: "#0f172a", background: "#ffffff", outline: "none" }}
                    onFocus={e => { e.target.style.borderColor = "#ea580c"; e.target.style.boxShadow = "0 0 0 3px rgba(234,88,12,0.12)"; }}
                    onBlur={e => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
                  />
                  <div className="h-3 pt-0.5">
                    {errors.nicheindustry && <span className="text-xs" style={{ color: "#dc2626" }}>{errors.nicheindustry}</span>}
                  </div>
                </div>

                <div>
                  <label htmlFor="hearUs" className="block text-sm font-medium mb-2" style={{ color: "#000000" }}>
                    How did you hear about us?
                  </label>
                  <select
                    id="hearUs"
                    name="hearUs"
                    value={formData.hearUs}
                    onChange={handleChange}
                    className="w-full text-sm transition"
                    style={{ border: "1px solid #e2e8f0", borderRadius: "999px", padding: "12px 18px", color: "#0f172a", background: "#ffffff", outline: "none", appearance: "none", backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\")", backgroundRepeat: "no-repeat", backgroundPosition: "right 16px center", paddingRight: "44px", cursor: "pointer" }}
                    onFocus={e => { e.target.style.borderColor = "#ea580c"; e.target.style.boxShadow = "0 0 0 3px rgba(234,88,12,0.12)"; }}
                    onBlur={e => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
                  >
                    <option value="" disabled>How Did You Hear Us</option>
                    <option>Media Article</option>
                    <option>Partner Connect</option>
                    <option>Social Media Post</option>
                    <option>Web Search</option>
                    <option>Word Of Mouth</option>
                    <option>Others</option>
                  </select>
                  <div className="h-3 pt-0.5">
                    {errors.hearUs && <span className="text-xs" style={{ color: "#dc2626" }}>{errors.hearUs}</span>}
                  </div>
                </div>
              </div>

              {/* Divider */}
              <hr style={{ border: "none", borderTop: "1px solid #f1f5f9", margin: "8px 0" }} />

              {/* Message */}
              <div>
                <label htmlFor="message" className="block text-sm font-medium mb-2" style={{ color: "#000000" }}>
                  How can we help?
                </label>
                <textarea
                  id="message"
                  name="about"
                  rows="4"
                  value={formData.about}
                  onChange={handleChange}
                  placeholder="Tell us what you need support with..."
                  className="w-full text-sm transition"
                  style={{ border: "1px solid #e2e8f0", borderRadius: "16px", padding: "12px 16px", color: "#0f172a", background: "#ffffff", outline: "none", minHeight: "105px", resize: "vertical" }}
                  onFocus={e => { e.target.style.borderColor = "#ea580c"; e.target.style.boxShadow = "0 0 0 3px rgba(234,88,12,0.12)"; }}
                  onBlur={e => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
                />
                <div className="h-3 pt-0.5">
                  {errors.about && <span className="text-xs" style={{ color: "#dc2626" }}>{errors.about}</span>}
                </div>
              </div>

              {/* Agreement */}
              <div className="mt-4 flex items-start gap-3" style={{ background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: "14px", padding: "11px 14px" }}>
                <input
                  id="agreement"
                  type="checkbox"
                  name="agreement"
                  checked={formData.agreement}
                  onChange={handleChange}
                  className="mt-0.5 h-4 w-4 flex-shrink-0 cursor-pointer"
                  style={{ accentColor: "#ea580c" }}
                />
                <label htmlFor="agreement" className="cursor-pointer text-sm leading-5" style={{ color: "#78350f" }}>
                  By submitting this form, you acknowledge that KCS Tech may use your personal information for marketing communications as outlined in its privacy policy.
                  <span style={{ color: "#dc2626", fontWeight: 600 }}> *</span>
                </label>
              </div>
              <div className="h-3 pt-0.5">
                {errors.agreement && <span className="text-xs" style={{ color: "#dc2626" }}>{errors.agreement}</span>}
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="mt-4 w-full text-sm font-semibold transition"
                style={{ background: "#ea580c", color: "#ffffff", borderRadius: "999px", padding: "12px", border: "none", cursor: "pointer", letterSpacing: "0.01em" }}
                onMouseEnter={e => e.target.style.background = "#c2410c"}
                onMouseLeave={e => e.target.style.background = "#ea580c"}
              >
                Submit Inquiry
              </button>

            </form>
          </div>
        </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;
